<template>
  <div class="transition-screen">
    <div class="transition-card">
      <span class="transition-card__icon">{{ icon }}</span>
      <p class="eyebrow">{{ eyebrow }}</p>
      <h2>{{ title }}</h2>
      <p class="transition-card__body">{{ body }}</p>
      <div v-if="items.length" class="type-list">
        <div v-for="item in items" :key="item.title" class="type-list__item">
          <strong>{{ item.title }}</strong><span>{{ item.text }}</span>
        </div>
      </div>
      <button class="primary-button" type="button" @click="$emit('continue')">{{ buttonText }}</button>
    </div>
  </div>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    eyebrow?: string
    title: string
    body: string
    buttonText: string
    icon?: string
    items?: Array<{ title: string; text: string }>
  }>(),
  {
    eyebrow: 'Meta Math',
    icon: '✦',
    items: () => [],
  },
)

defineEmits<{ continue: [] }>()
</script>
